import { PanelBody, PanelRow, Spinner, Button, SelectControl, __experimentalGrid as Grid, __experimentalText as Text, CheckboxControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { useEffect, useState } from '@wordpress/element'
import React from 'react';

const SidebarFilters = () => {
    const [page, setPage] = useState('filters');
    const [isLoading, setIsLoading] = useState(true);
    const [filters, setFilters] = useState([]);
    const [filterMetaData, setFilterMetaData] = useState([]);
    const [reportFilter, setReportFilter] = useState({});
    const [metaDataCollection, setMetaDataCollection] = useState([]);
    const [csvSettings, setCSVSettings] = useState([])
    const postId = useSelect((select) => select('core/editor').getCurrentPostId(), [])

    const meta = useSelect((select) =>
        select('core/editor').getEditedPostAttribute('meta') ? select('core/editor').getEditedPostAttribute('meta')['report_collection_id'] : 0
    )

    const isOpen = useSelect((select) =>
        select('core/edit-post').isPluginSidebarOpened('filter-sidebar')
    )

    const [filterType, setFilterType] = useState('AND')

    useEffect(() => {
        if ((isOpen) & (filters.length < 1)) {
            populateFilters(meta)
        }

    }, [isOpen])

    const populateTags = (newValue) => {
        setIsLoading(true)
        fetch(`${wpApiSettings.root}tainacan/v2/collection/${newValue}/metadata`)
            .then((response) => response.json())
            .then((data) => {
                let filterMetaData = []

                data.forEach(element => {
                    if (element) {
                        filterMetaData.push({
                            meta: element.name,
                            slug: element.slug.toUpperCase()
                        })
                    }
                })
                setIsLoading(false);
                setMetaDataCollection(filterMetaData)
            })
            .catch(() => setIsLoading(false));
    }

    const populateFilters = (collectionId) => {
        setIsLoading(true)
        const promises = []

        fetch(`${wpApiSettings.root}tainacan/v2/collection/${collectionId}/filters`)
            .then((response) => response.json())
            .then((data) => {
                const filterMetaDataResult = []
                data?.forEach(element => {
                    if (element) {
                        let taxOrMetaDataTumId = element.metadatum_id

                        if (element.metadatum.metadata_type_object.options.taxonomy) {
                            taxOrMetaDataTumId = element.metadatum.metadata_type_object.options.taxonomy
                        }

                        filterMetaDataResult.push({
                            id: element.id,
                            name: element?.name,
                            metadatum_id: element.metadatum_id,
                            taxonomy: taxOrMetaDataTumId
                        })

                        promises.push(
                            fetch(`${wpApiSettings.root}tainacan/v2/collection/${collectionId}/facets/${element?.metadatum_id}?number=80&current_query[perpage]=50&current_query[paged]=1`)
                                .then(response => response.json())
                        )
                    }
                })

                Promise.all(promises)
                    .then((results) => {
                        const filterItem = []
                        results.forEach((result, index) => {
                            result?.values.forEach(element => {
                                filterItem.push({
                                    id: element.value,
                                    name: element.label,
                                    total: element.total_items,
                                    taxonomy: element.taxonomy,
                                    metadatumId: data[index].metadatum_id
                                })
                            })
                        })

                        setFilterMetaData(filterItem)
                    }).finally(() => { setIsLoading(false) })

                setFilters(filterMetaDataResult)
            })
    }

    const filterMetaDataFunction = (filterId) => {
        const filtersMetaDataOptions = []

        filterMetaData.forEach((itemMetaData) => {
            if (parseInt(itemMetaData.metadatumId) == parseInt(filterId)) {
                filtersMetaDataOptions.push({
                    value: itemMetaData.id,
                    label: '(' + itemMetaData.total + ') ' + itemMetaData.name
                })
            }
        })

        return filtersMetaDataOptions
    }

    const concatFilters = (filterMetaTumId, filterId) => {
        if (filterMetaTumId < 1 || filterId < 1 || !reportFilter) {
            return
        }

        const currentFilter = reportFilter
        currentFilter[filterMetaTumId] = filterId
        setReportFilter(currentFilter)
    }


    const handleButtonClickPDF = () => {
        let filterParam = '';
        if (reportFilter) {
            filterParam = JSON.stringify(reportFilter)
        }
        const nonce = window.tainacanReportsNonces?.generate_report || '';
        if (!nonce) {
            return;
        }
        window.open(`/tainacan-report/generator/?reportId=${postId}&filters=${filterParam}&pdf=true&filterType=${filterType}&_wpnonce=${nonce}`, '_blank')
    }

    const handleButtonClickGenerateCSV = () => {
        let filterParam = '';
        if (reportFilter) {
            filterParam = JSON.stringify(reportFilter)
        }

        let csvSettingsParam = '';
        if (csvSettings) {
            csvSettingsParam = JSON.stringify(csvSettings)
        }

        console.log(csvSettings)
        console.log(csvSettingsParam)

        const nonce = window.tainacanReportsNonces?.generate_report || '';
        if (!nonce) {
            return;
        }
        window.open(`/tainacan-report/generator/?reportId=${postId}&filters=${filterParam}&filterType=${filterType}&csvSettings=${csvSettingsParam}&_wpnonce=${nonce}`, '_blank')
    }

    const handleButtonClickCSV = (collectionId) => {
        populateTags(collectionId)
        setPage('csv')
    }

    const handleCheckboxChange = (id, isChecked) => {
        setCSVSettings((prev) =>
            isChecked ? [...prev, id] : prev.filter((item) => item !== id)
        )
    }

    return (
        <>
            {page === 'filters' ? (
                <PanelBody title="Filtros de itens para coleção" initialOpen={false}>
                    {isLoading ? (
                        <Spinner />
                    ) : (
                        <>
                            {filters.map((filter) => (
                                <PanelRow>
                                    <React.Fragment key={filter.id}>
                                        <SelectControl
                                            multiple
                                            label={filter.name}
                                            onChange={(filterItem) => { concatFilters(filter.taxonomy, filterItem) }}
                                            options={filterMetaDataFunction(filter.metadatum_id)}
                                            __nextHasNoMarginBottom
                                        />
                                    </React.Fragment>
                                </PanelRow>
                            ))}
                            <PanelRow>
                                <SelectControl
                                    label="Tipo do filtro"
                                    value={filterType}
                                    options={[
                                        { label: 'Filtrar', value: 'AND' },
                                        { label: 'Agrupar', value: 'OR' },
                                    ]}
                                    onChange={(newType) => setFilterType(newType)}
                                    __next40pxDefaultSize
                                    __nextHasNoMarginBottom
                                />
                            </PanelRow>
                            <PanelRow>
                                <Button variant="primary" onClick={handleButtonClickPDF}>Gerar relatório</Button>
                                <Button variant="primary" onClick={() => handleButtonClickCSV(meta)}>Gerar CSV</Button>
                            </PanelRow>
                        </>
                    )
                    }
                </PanelBody>
            ) : (
                <PanelBody title="Configurações">
                    <Grid columns={2}>
                        <CheckboxControl
                            key={'DIA'}
                            label={'DIA'}
                            checked={csvSettings.includes('DIA')}
                            onChange={(isChecked) => handleCheckboxChange('DIA', isChecked)}
                        />
                        <CheckboxControl
                            key={'MES'}
                            label={'MÊS'}
                            checked={csvSettings.includes('MES')}
                            onChange={(isChecked) => handleCheckboxChange('MES', isChecked)}
                        />
                        <CheckboxControl
                            key={'ANO'}
                            label={'ANO'}
                            checked={csvSettings.includes('ANO')}
                            onChange={(isChecked) => handleCheckboxChange('ANO', isChecked)}
                        />
                        <CheckboxControl
                            key={'URL'}
                            label={'URL'}
                            checked={csvSettings.includes('URL')}
                            onChange={(isChecked) => handleCheckboxChange('URL', isChecked)}
                        />
                        {metaDataCollection.map((value) => (
                            <CheckboxControl
                                key={value.slug}
                                label={value.slug}
                                checked={csvSettings.includes(value.slug)}
                                onChange={(isChecked) => handleCheckboxChange(value.slug, isChecked)}
                            />
                        ))}

                    </Grid>
                    <Button variant="primary" onClick={handleButtonClickGenerateCSV}>Gerar CSV</Button>
                    <Button onClick={() => setPage('filters')}>Voltar</Button>
                </PanelBody>
            )}
        </>
    );
};

export default SidebarFilters
